import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const getSkillAgentTasksMeta = async () => {
  const response = await axios.get(`${API_URL}/api/skill-agent-tasks/meta`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const listSkillAgentTasks = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-tasks`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentTaskById = async (id) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-tasks/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const createSkillAgentTask = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-tasks`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSkillAgentTask = async (id, payload) => {
  const response = await axios.put(
    `${API_URL}/api/skill-agent-tasks/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const dispatchSkillAgentTask = async (id, body = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-tasks/${id}/dispatch`,
    body,
    { headers: authHeaders() },
  );
  return response.data;
};

export const runSkillAgentTask = async (id, body = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-tasks/${id}/run`,
    body,
    { headers: authHeaders() },
  );
  return response.data;
};

export const listSkillAgentArtifacts = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-tasks/${id}/artifacts`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const pushSkillAgentArtifactsToDrive = async (id, body = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-tasks/${id}/artifacts/push-drive`,
    body,
    { headers: authHeaders() },
  );
  return response.data;
};

/** Fetch artifact image with auth and return a blob: URL (revoke when done). */
export const fetchSkillAgentArtifactBlobUrl = async (artifactId) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-tasks/artifacts/${artifactId}/file`,
    { headers: authHeaders(), responseType: "blob" },
  );
  return URL.createObjectURL(response.data);
};

export const markSkillAgentTaskDone = async (id, summary = "") => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-tasks/${id}/mark-done`,
    { summary },
    { headers: authHeaders() },
  );
  return response.data;
};

export const markSkillAgentTaskReview = async (id, summary = "") => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-tasks/${id}/mark-review`,
    { summary },
    { headers: authHeaders() },
  );
  return response.data;
};

export const cancelSkillAgentTask = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-tasks/${id}/cancel`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillAgentTask = async (id) => {
  const response = await axios.delete(`${API_URL}/api/skill-agent-tasks/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};
